import React from "react"
import {RefTable, DefaultProps} from "../RefTable"

export const VatRegistration = (props)=><RefTable {...props}/>;

VatRegistration.defaultProps = {
    ...DefaultProps,
    title: "EAS VAT Registrations",
    tableSchema: "eas_vat_reg_info",
    tableName: "eas_vat_reg_info",
    edit: true,
}
